
import { GET } from './NetService';

const Action = "cuenta/";

export async function getReporteCuenta(bsignal,hospital,cuentaID)
{
    return await GET(Action+"Ver/"+hospital+'/'+cuentaID,bsignal);
}